import { HttpStatusCode } from '@angular/common/http';
import { ErrorMessages } from '../constants/error.constant';
export enum ModalStatus {
  OPEN = 'open',
  CLOSE = 'close'
}

export enum ReqStatus {
  INIT = 'init',
  LOADING = 'loading',
  SUCCESS = 'success',
  EMPTY = 'empty',
  ERROR = 'error',
  TIMEOUT = 'timeout'
}
export interface ReqState {
  reqStatus: ReqStatus;
  httpCode: HttpStatusCode | null;
  cyberCode: number;
  modalStatus: ModalStatus | null;
  message: string;
}

export const DEFAULT_REQ_STATE: ReqState = {
  message: '',
  reqStatus: ReqStatus.INIT,
  httpCode: null,
  cyberCode: 0,
  modalStatus: ModalStatus.CLOSE
};

export const REQ = {
  isLoading: (req: ReqState) => req?.reqStatus === ReqStatus.LOADING,
  isError: (req: ReqState) => req?.reqStatus === ReqStatus.ERROR,
  isSuccess: (req: ReqState) => req?.reqStatus === ReqStatus.SUCCESS,
  isEmpty: (req: ReqState) =>
    req?.reqStatus === ReqStatus.SUCCESS &&
    req?.httpCode === HttpStatusCode.NoContent,
  isTimeout: (req: ReqState) => req?.reqStatus === ReqStatus.TIMEOUT,
  isModalOpen: (req: ReqState) => req?.modalStatus === ModalStatus.OPEN,
  isModalClose: (req: ReqState) => req?.modalStatus === ModalStatus.CLOSE,
  getMessage: (req: ReqState, message: string) =>
    getMessage(req?.reqStatus, message, req?.httpCode)
};
//WIP
// export function updateReq(req: ReqState) {
//   return {
//     success: () => {
//       req.reqStatus = ReqStatus.SUCCESS;
//       return this;
//     },
//     error: () => {
//       req.reqStatus = ReqStatus.ERROR;
//       return this;
//     },
//     openModal: () => {
//       req.modelStatus = ModalStatus.OPEN;
//       return this;
//     },
//     closeModal: () => {
//       req.modelStatus = ModalStatus.CLOSE;
//       return this;
//     }
//   };
// }

// Helper function to detect technical error messages that should not be shown to users
const isGenericOrTechnicalMessage = (message: string): boolean => {
  if (!message || !message.trim()) return true;

  const trimmedMessage = message.trim();

  // Filter Angular's HTTP error responses (technical, not user-friendly)
  // Example: "Http failure response for https://api.example.com: 504 Gateway Timeout"
  if (trimmedMessage.match(/^Http failure response/i)) {
    return true;
  }

  // Filter if message contains full URLs (security/privacy concern)
  // Prevents exposing internal API paths to end users
  if (trimmedMessage.match(/https?:\/\/[^\s]+/i)) {
    return true;
  }

  // Let everything else through - backend-defined messages are intentional
  return false;
};

export const getMessage = (
  status?: ReqStatus,
  message?: string,
  httpCode?: number
) => {
  // Priority 1: Check for gateway/network errors first
  if (httpCode !== undefined && httpCode !== null) {
    switch (httpCode) {
      case 0:
        return ErrorMessages.NETWORK_ERROR;
      case HttpStatusCode.BadGateway:
        return ErrorMessages.BAD_GATEWAY_ERROR;
      case HttpStatusCode.ServiceUnavailable:
        return ErrorMessages.SERVICE_UNAVAILABLE_ERROR;
      case HttpStatusCode.GatewayTimeout:
        return ErrorMessages.GATEWAY_TIMEOUT_ERROR;
      default:
        // Handle all other 5xx server errors
        if (httpCode >= 500 && httpCode < 600) {
          return ErrorMessages.SERVER_ERROR;
        }
    }
  }

  // Priority 2: Use custom message if provided (but filter technical messages)
  if (message && !isGenericOrTechnicalMessage(message)) {
    return message;
  }

  // Priority 3: Fallback to ReqStatus default messages
  let defaultMessage = 'Something went wrong, please try again';
  switch (status) {
    case ReqStatus.ERROR:
      defaultMessage = 'Error occurred, please try again';
      break;
    case ReqStatus.TIMEOUT:
      defaultMessage = 'Request timed out, please try again';
      break;
    case ReqStatus.LOADING:
      defaultMessage = 'Loading';
      break;
    case ReqStatus.SUCCESS:
      defaultMessage = 'Successful';
      break;
  }
  return defaultMessage;
};
